// *******************
// Shorthand Selectors
// *******************

function s(e) {
  return document.querySelector(e);
}
function sa(e) {
  return document.querySelectorAll(e);
}
// ****************
// Get Product Info
// ****************

sa(".print-product").forEach((product) => {
  product.addEventListener("click", () => {
    let productTitle = product.getAttribute("data-product");
    let cssClass = productTitle.replace(/[^a-zA-Zs+]/g, "").toLowerCase();
    let productID = product.firstElementChild.getAttribute("id");
    if (s("#" + productID).checked == true && s("." + cssClass) == null) {
      loadProductSection(productTitle, cssClass);
    } else {
      if (s("#" + productID).checked == false && s("." + cssClass) !== null) {
        removeProductSection(cssClass);
      }
    }
  });
});

// *******************
//Load Product Section
// *******************

//Global Quantity

let quantity = " ";

for (let i = 1; i < 101; i++) {
  quantity += "<option value='" + i + "'>" + i + "</option>";
}

function loadProductSection(product, cssClass) {
  // Title
  let output = '<div class="product-section ' + cssClass + '">      <hr /><strong> ' + product + " Printing - Upload Your Artwork </strong>";
  // Body Copy
  output += "<p>Please upload the mockup image of your Arma design. If your design was not created by Arma please provide a .Ai vector print file. Please note first time custom product orders have a minimum order quantity of 4pcs.</p>";

  // File Upload
  output += '<label class="file-upload"><input type="file" /><span>Upload</span></label>';

  // Product Info
  let limitForm = "";
  if (cssClass == "elitejacket") {
    limitForm = "limit-" + cssClass;
  }
  if (cssClass == "elitehoodie") {
    limitForm = "limit-" + cssClass;
  }
  if (cssClass == "baseballjersey") {
    limitForm = "limit-" + cssClass;
  }
  if (cssClass == "joggers") {
    limitForm = "limit-" + cssClass;
  }
  if (cssClass == "zipjacket") {
    limitForm = "limit-" + cssClass;
  }

  output +=
    "<strong>Your Custom " +
    product +
    ' Information</strong><div class="item-' +
    cssClass +
    '"><div class="info-item info-' +
    cssClass +
    " " +
    limitForm +
    '"><p>' +
    " 01" +
    '</p><label for="size"><span>Size</span><select type="text" name="Size" id="size"/><option value="" disabled selected>--</option><option value="XS">XS</option><option value="S">S</option><option value="M">M</option><option value="L">L</option><option value="XL">XL</option><option value="2XL">2XL</option><option value="3XL">3XL</option><option value="4XL">4XL</option><option value="5XL">5XL</option></select></label><label for="quantity"><span>Quantity</span><select name="Quantity" id="quantity"/>' +
    quantity +
    '</select></label><label for="alias"><span>Alias (If Applicable)</span><input type="text" name="Alias" id="alias"/></label><label for="g-name"><span>Full Name (If Applicable)</span><input type="text" name="Garment Name" id="g-name"/></label><label for="flag"><span>Flag (If Applicable)</span><input type="text" name="Flag" id="flag"/></label><label for="number"><span>Number (If Applicable)</span><input type="text" name="Number" id="number"/></label><label for="sleeve"><span>Sleeve</span><select name="Sleeve" id="sleeve"/><option disabled value="" selected>--</option><option value="Short">Short</option><option value="Long">Long</option></select></label><label for="fit" ><span>Fit</span><select name="Fit" id="fit"/><option selected value="" disabled>--</option><option value=""Men>Men</option><option value="Women">Women</option></select></label><span class="remove hidden" onClick="">✕</span></div></div>';

  // Add More Button
  output += "<a class='add-item add-" + cssClass + "' data-add='" + cssClass + "' data-title=" + product + "'>+ ADD " + product + "</a></div>";

  s(".print-order-details").innerHTML += output;

  // Add Click Event for dynamically created button

  sa(".add-item").forEach((item) => {
    item.addEventListener("click", (e) => {
      additionalItems(e);
    });
  });
}

// ************************
// Remove Product Section
// ************************

function removeProductSection(cssClass) {
  s("." + cssClass).remove();
}

// ************************
// Load Additional Products
// ************************

function additionalItems(e) {
  const selectItem = e.target.classList[1].replace("add-", "");
  const itemTitle = e.target.getAttribute("data-title");
  let limitForm = "";
  if (selectItem == "elitejacket") {
    limitForm = "limit-" + selectItem;
  }
  if (selectItem == "elitehoodie") {
    limitForm = "limit-" + selectItem;
  }
  if (selectItem == "baseballjersey") {
    limitForm = "limit-" + selectItem;
  }
  if (selectItem == "joggers") {
    limitForm = "limit-" + selectItem;
  }
  if (selectItem == "zipjacket") {
    limitForm = "limit-" + selectItem;
  }
  let itemCount = sa(".info-" + selectItem).length + 1;
  itemCount = itemCount++;
  s(".item-" + selectItem).innerHTML +=
    '<div class="info-item info-' +
    selectItem +
    " " +
    selectItem +
    itemCount +
    " " +
    limitForm +
    '"><p>' +
    "0" +
    itemCount +
    "" +
    '</p><label for="size"><span>Size</span><select type="text" name="Size" id="size"/><option value="" disabled selected>--</option><option value="XS">XS</option><option value="S">S</option><option value="M">M</option><option value="L">L</option><option value="XL">XL</option><option value="2XL">2XL</option><option value="3XL">3XL</option><option value="4XL">4XL</option><option value="5XL">5XL</option></select></label><label for="quantity"><span>Quantity</span><select name="Quantity" id="quantity"/>' +
    quantity +
    '</select></label><label for="alias"><span>Alias (If Applicable)</span><input type="text" name="Alias" id="alias"/></label><label for="g-name"><span>Full Name (If Applicable)</span><input type="text" name="Garment Name" id="g-name"/></label><label for="flag"><span>Flag (If Applicable)</span><input type="text" name="Flag" id="flag"/></label><label for="number"><span>Number (If Applicable)</span><input type="text" name="Number" id="number"/></label><label for="sleeve"><span>Sleeve</span><select name="Sleeve" id="sleeve"/><option disabled value="" selected>--</option><option value="Short">Short</option><option value="Long">Long</option></select></label><label for="fit" ><span>Fit</span><select name="Fit" id="fit"/><option selected value="" disabled>--</option><option value=""Men>Men</option><option value="Women">Women</option></select></label><span class="remove" onClick="document.querySelector(' +
    "'." +
    selectItem +
    itemCount +
    "'" +
    ').remove()"><span class="text">Remove</span>✕</span></div>';
}

// ************************
// Display Design Product
// ************************

sa(".design-product").forEach((product) => {
  product.addEventListener("click", () => {
    var textinputs = document.querySelectorAll("input[type=checkbox]");
    var empty = [].filter.call(textinputs, function (el) {
      return !el.checked;
    });

    if (textinputs.length == empty.length) {
      s(".design-order-details").style.display = "none";
      return false;
    } else {
      s(".design-order-details").style.display = "block";
    }
  });
});

// ************
// Select Form
// ************

s(".design").addEventListener("click", function () {
  s(".custom-form-container").classList.add("design-form-open");
  s(".custom-form-container").classList.remove("print-form-open");
  s(".design").classList.add("design-clicked");
  s(".print").classList.remove("print-clicked");
});

s(".print").addEventListener("click", function () {
  s(".custom-form-container").classList.add("print-form-open");
  s(".custom-form-container").classList.remove("design-form-open");
  s(".design").classList.remove("design-clicked");
  s(".print").classList.add("print-clicked");
});
